import React, { PureComponent } from 'react';
import ButtonExpandir from './ButtonExpandir'

class TablaRow extends PureComponent {
    constructor(props) {
        super(props);

        this.onClickdestildarTildarCheck = this.onClickdestildarTildarCheck.bind(this);
    }

    onClickdestildarTildarCheck(Id, tipoCheck, estadoCheck) {
        this.props.destildarTildarCheck(Id, tipoCheck, estadoCheck);
    }

    render() {
        const { ajusteCargo, expandirRow, claseFlecha, state, setEstaDesplegado, backColor, tieneScroll, checkConfirmar, checkDenegarRestablecer, user } = this.props;

        let importeSinIva = ajusteCargo.DescripcionMoneda.toLocaleLowerCase() == "pesos" ? "$" + ajusteCargo.ImporteSinIva : "u$s" + ajusteCargo.ImporteSinIva
        let fechaIngreso = ajusteCargo.FechaIngreso != null ? ajusteCargo.FechaIngreso.substring(8, 10) + '/' + ajusteCargo.FechaIngreso.substring(5, 7) + '/' + ajusteCargo.FechaIngreso.substring(2, 4) : null;;
        let documento = ajusteCargo.Documento && ajusteCargo.Documento.toString();
        documento = documento && documento.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        let numeroCuenta = ajusteCargo.NumeroCuenta;
        let debitoCredito = ajusteCargo.DebitoCredito;
        let codigo = ajusteCargo.Codigo;
        let motivo = ajusteCargo.DescripcionMotivo;
        let mismoUsario = user[0].Login == ajusteCargo.UsuarioAlta;
        //Se muestra negativo el importe dependiendo de si es Débito o Crédito
        importeSinIva = debitoCredito == 'D' ? "(" + importeSinIva + ")" : importeSinIva;

        return (
            <tr className={"confirmadorAjusteCargoTableRow " + backColor}>
                
                <div className={"confirmadorAjusteCargoTableCell confirmadorAjusteCargoTableCellConfirmar"}>
                    <div className={"confirmadorAjusteCargoTableCellMotivoInsideDiv"}>
                        <div className={"default-checkbox checkProcesosSmall"}>
                        {!mismoUsario ? <input type="checkbox" onClick={() => this.onClickdestildarTildarCheck(ajusteCargo.Id, "C", checkConfirmar)} checked={checkConfirmar} /> : null}
                        </div>
                    </div>
                </div>
                <div className={"confirmadorAjusteCargoTableCell confirmadorAjusteCargoTableCellDenegarRestablecer"}>
                    <div className={"confirmadorAjusteCargoTableCellMotivoInsideDiv"}>
                        <div className={"default-checkbox checkProcesosSmall"}>
                        {!mismoUsario ? <input type="checkbox" onClick={() => this.onClickdestildarTildarCheck(ajusteCargo.Id, "DR", checkDenegarRestablecer)} checked={checkDenegarRestablecer} /> : null}
                        </div>
                    </div>
                </div>
                <div className={"confirmadorAjusteCargoTableCell confirmadorAjusteCargoTableCellDocumento"}>
                    <div className={"confirmadorAjusteCargoTableCellMotivoInsideDiv"}>{documento ? documento : "-"}</div>
                </div>
                <div className={"confirmadorAjusteCargoTableCell confirmadorAjusteCargoTableCellNumeroCuenta"}>
                    <div className={"confirmadorAjusteCargoTableCellMotivoInsideDiv"}>{numeroCuenta ? numeroCuenta : "-"}</div>
                </div>
                <div className={"confirmadorAjusteCargoTableCell confirmadorAjusteCargoTableCellDebitoCredito"}>
                    <div className={"confirmadorAjusteCargoTableCellMotivoInsideDiv"}>{debitoCredito ? debitoCredito : "-"}</div>
                </div>
                <div className={"confirmadorAjusteCargoTableCell confirmadorAjusteCargoTableCellCodigo"}>
                    <div className={"confirmadorAjusteCargoTableCellMotivoInsideDiv"}>{codigo ? codigo : "-"}</div>
                </div>
                <div className={"confirmadorAjusteCargoTableCell confirmadorAjusteCargoTableCellMotivo"}>
                    <div className={"confirmadorAjusteCargoTableCellMotivoInsideDiv"}></div>
                    <div className={"confirmadorAjusteCargoTableCellMotivoInsideDiv"}>{motivo ? motivo : "-"}</div>
                </div>
                <div className={"confirmadorAjusteCargoTableCell confirmadorAjusteCargoTableCellImporteSinIva"}>
                    <div className={"confirmadorAjusteCargoTableCellMotivoInsideDiv"}>{ajusteCargo.ImporteSinIva ? importeSinIva : "-"}</div>
                </div>
                <div className={"confirmadorAjusteCargoTableCell " + (tieneScroll ? "confirmadorAjusteCargoTableCellFechaIngresoConScroll" : "confirmadorAjusteCargoTableCellFechaIngreso")}>
                    <div className={"confirmadorAjusteCargoTableCellMotivoInsideDiv"}>{fechaIngreso ? fechaIngreso : "-"}</div>
                </div>
                <div className={"confirmadorAjusteCargoTableCell confirmadorAjusteCargoTableCellBtnExpandir"}>
                    <div className={"confirmadorAjusteCargoTableCellMotivoInsideDiv"}>
                        <ButtonExpandir
                            id={ajusteCargo.Id}
                            setEstaDesplegado={setEstaDesplegado}
                            estaDesplegado={state.estaDesplegado}
                            expandirRow={expandirRow}
                            claseFlecha={claseFlecha} />
                    </div>
                </div>
            </tr>
        );
    }
}

export default TablaRow;